<ng-container *transloco="let t">
  <div class="option-heading">
    <div>
      <label class="option-name">
        {{ name() }}
      </label>
      @if (instructions()) {
        <h3 class="option-instructions">{{ instructions() }}</h3>
      }
    </div>
    @if (isOptional()) {
      <span class="option-condition">{{ t('product.optionSelectionOptional') }}</span>
    } @else if (isRequired()) {
      <span class="option-condition">{{ t('product.optionSelectionRequired') }}</span>
    }
  </div>
  <div class="option-items">
    <ng-content></ng-content>
  </div>
</ng-container>
